module.exports = __webpack_public_path__ + "static/media/three-number.3223e69f.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/three-number.png
// module id = 1041
// module chunks = 0